import * as React from "react";
import * as WhiteSpinnerLoading from "./spinner/WhiteSpinnerLoading.primitive.js";
import * as ErrorMessageMedgo from "./ErrorMessageMedgo.primitive.js";
function ButtonLanding({
  text,
  nextPage,
  width,
  backgroundColor = "",
  isTtransparent = false,
  isLoading = false,
  errorMessage = "",
  type = "button"
}: {
  text: string;
  nextPage: (value: any) => any;
  width?: string;
  backgroundColor?: "is-blue" | "is-comet" | "";
  isTtransparent?: boolean;
  isLoading?: boolean;
  errorMessage?: string;
  type?: "button" | "submit";
}) {
  let transparent = isTtransparent ? " is-transparent" : "";
  return (
    <div>
      <ErrorMessageMedgo label={errorMessage} type={" is-landing"} />

      <button
        className={"button-landing text-bold " + backgroundColor + transparent}
        onClick={isLoading ? () => {} : nextPage}
        style={{ width }}
        type={type}
      >
        {isLoading ? (
          <div
            className="text-center"
            style={{ position: "absolute", top: errorMessage !== "" ? "70%" : "60%", left: "48%" }}
          >
            <WhiteSpinnerLoading isLoading={isLoading} />
          </div>
        ) : null}
        <span style={{ opacity: isLoading ? 0 : 1 }}>{text}</span>
      </button>
    </div>
  );
}

export default ButtonLanding;



// WEBPACK FOOTER //
// ./assets/react/views/primitive/ButtonLanding.primitive.tsx